const car= (state = [], action) => {

    switch(action.type){
        case 'FETCH_CAR': 
            return state.map( car => {
                if(action.car.id === car.id) return action.car
                return car
            })
        case 'FETCH_CARS': return action.cars 
        case 'ADD_CAR': return [...state, action.car]
        case 'LOG_OUT': return []
        default: return state
    }
}

export const getCars = (state) => state
export const getCar = (state, id) => state.reduce((p, car) => {
    if (car.id === Number(id)) return car
    return p
}, {})


export default car